import { render } from "./OkrugQuarters.vue?vue&type=template&id=25ca5aea&scoped=true"
import script from "./OkrugQuarters.vue?vue&type=script&lang=js"
export * from "./OkrugQuarters.vue?vue&type=script&lang=js"

import "./OkrugQuarters.vue?vue&type=style&index=0&id=25ca5aea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ca5aea"]])

export default __exports__